module.exports = __webpack_public_path__ + "static/img/Portal Photo_FamilyImage1.91eef29.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/FamilyImages/Portal Photo_FamilyImage1.jpeg
// module id = 357
// module chunks = 4